<div class="row d-flex" style="justify-content: right; align-items: flex-start;">
    
    <div class="offset-7 col-4 my-3 mr-2 pr-4">

        <div class="py-2" style="margin-left: 15px; margin-top: -30px;">
            <textarea [name]="question.questionId" rows=6 cols=80 [(ngModel)]="comments"
                (ngModelChange)="onCommentsChange($event)" [(disabled)]="isReadOnly"
                placeholder="Enter Resolution Comments" class="txtComments" style="width: 100%; resize: vertical;"
                maxlength="2000">
            </textarea>
            <div class="mt-1" *ngIf="comments && comments.trim().length > 0" style="font-size: 12px;"
                class="text-muted">
                {{comments.length}}/2000 characters
            </div>
        </div>

        <!-- File Validation Error Messages -->
        <div *ngIf="errorMessages.length > 0" class="alert alert-danger mt-2" style="margin-left: 15px; font-size: 12px;">
            <div *ngFor="let error of errorMessages">
                {{error}}
            </div>
        </div>


<!-- 
        <div  *ngIf="question.inputType === 'fileupload'"  style="margin-left: 15px;"> -->
           <div  style="margin-left: 15px;">
            <div class="mb-3" *ngIf="!isReadOnly">
                <button class="filledBtnStyle" style="padding: 5px; width: 120px;"
                    (click)="openBrowseWindow(question.questionId)">Upload File</button>
                
                <input type="file" class="d-none" id="uploadfile{{question.questionId}}" name="uploadFile"
                    (change)="onFileChange($event.target.files)" [ariaLabel]="question.questionText" multiple>
            </div>

            <div *ngIf="attachedFiles.length > 0" class="uploaded-files-container">
                <div class="files-vertical-list">
                    <div *ngFor="let entry of attachedFiles; let z = index;" class="file-item mb-2 p-2 fileStyle">
                        <div class="d-flex justify-content-between align-items-center">
                            <a title="{{entry.name ?? entry.file.name}}" class="downloadBtn text-truncate" 
                            (click)="downloadFile(entry)" style="max-width: 150px;">
                                {{ entry.name ?? entry.file.name}}
                            </a>
                             <div *ngIf="entry.isLoading" class="spinner-border spinner-border-sm text-primary" role="status" style="margin-left: 8px; vertical-align: middle;">
                            </div>
                            <img *ngIf="!isReadOnly && !entry.isLoading" src="/assets/icons/Delete1.svg" class="deleteBtn ml-2" matTooltip="Delete"
                                [matTooltipPosition]="'above'" [style.pointerEvents]="isReadOnly ? 'none' : 'auto'"
                                [style.opacity]="isReadOnly ? 0.5 : 1"
                                (click)="deleteFile(z)" alt="Delete icon">
                        </div>
                    </div>
                </div>
            </div>                    
        </div> 

    </div>
</div>
